// extracted by mini-css-extract-plugin
export default {"label":"label-3xe1Ii","flush":"flush-3y6hs-","requiredIndicator":"requiredIndicator-2r1Vwi"};